module.exports = __webpack_public_path__ + "img/NovigoLogo.ad981395.png";